// SDK early listener — captures AUTH/INIT postMessage BEFORE React initialization.
// Origin'ы Hub'а зашиты в getAllowedOrigins; env/runtime-config лишь расширяют список.
// Раньше здесь читался только VITE_ALLOWED_ORIGINS, который в собранном бандле был
// пустым (Vite вшивает env на build, а Nomad задавал его в runtime), поэтому ранний
// INIT от Hub'а отбрасывался — это одна из причин вечного «Подключение к Hub».
import { configureEarlyListener } from '@aseller/embed-sdk';
import { getAllowedOrigins } from './utils/allowedOrigins';
configureEarlyListener({ allowedOrigins: getAllowedOrigins() });

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
